import { Box, CircularProgress, Stack } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  canSendSms,
  // getSmsLogs,
  ICandidate,
  ISmsLog,
  // sendSms,
  // createOrGetMapping,
  // createOrGetMappingForEdit,
  validatePhoneNumber,
  getCandidateById,
  getJobCandidateInteraction,
  IJob,
  sendBulkSms,
  IBulkSmsDTO,
  getSMSLogsV2,
  SearchComLogReq,
  getWorkAssignmentByCurrentRecruiterAndJob,
} from 'wisestep-api';
import {
  IMessageData,
  IMsg,
  WsChatBox,
  WsColors,
  WsSelectObj,
  WsTypoColors,
  WsTypography,
  WsTypoVariants,
} from 'wisestep-base';

import { useUserContext, useWorkspaceContext } from '../../context';
import { getCachedJob } from '../../utils/cacheService';
import { failed, success } from '../../utils/NotificationMessages';
import { useNotificationStore } from '../../utils/NotificationStore';
import { useConversationWidgetStore } from '../../utils/useConversationWidgetStore';
import { useWorkspaceCredit } from '../BulkSms/helper/apiCalls';

import { getPhoneNumbers } from './helper/apiCalls';
// import { sendSmsPayload } from './helper/payload';
import WsChatBoxNew from './WsChatBoxNew';

export interface ISMSChatBoxProps {
  candidate: ICandidate;
  receiverPhoneNumber: string;
  amplitudeEventHandler?: (eventType: string) => void;
  onSubmit?: () => void;
  selectedJob?: IJob | null;
}

const SMSChatBox = ({
  candidate,
  receiverPhoneNumber,
  amplitudeEventHandler,
  onSubmit,
}: ISMSChatBoxProps) => {
  const availableCredit = useWorkspaceCredit();
  const fromPage = useConversationWidgetStore((state) => state.fromPage);
  const activityConversation = useConversationWidgetStore((state) => state.activityConversation);
  const [selectedInteraction, setSelectedInteraction] = useState<ICandidate>();
  const [to, setTo] = useState(receiverPhoneNumber);

  const [phoneNumbers, setPhoneNumbers] = useState<WsSelectObj[]>([]);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const location = useLocation();
  const pathName = location.pathname;
  const user = useUserContext();
  useEffect(() => {
    const fetchPhoneNumbers = async () => {
      try {
        setIsLoading(true);
        const data = await getPhoneNumbers(user.userDTO?.email ?? '');
        setPhoneNumbers(data);
        setIsLoading(false);
      } catch (e) {
        setPhoneNumbers([]);
        setIsLoading(false);
      }
    };

    const initializeInteraction = async () => {
      let passedCandidate = candidate;
      // let interactionToUse: ICandidate;
      if (fromPage !== 'talentpool' && candidate.id && !pathName.includes('candidate-layout')) {
        const interactionRecord = await getJobCandidateInteraction(candidate.id);
        const candidateRecord = await getCandidateById(interactionRecord.data.candidateId);
        passedCandidate = candidateRecord.data;
      }
      // if (!activityConversation) {
      const cachedJob = await getCachedJob();
      const { data: workAssignment } = await getWorkAssignmentByCurrentRecruiterAndJob(
        cachedJob?.id ?? ''
      );
      console.log(workAssignment?.team?.id);
      const interactionPayload = { ...passedCandidate };
      interactionPayload.jobId = cachedJob.id;
      interactionPayload.mappedJobTitle = cachedJob.title;
      interactionPayload.team = workAssignment?.team ?? null;
      interactionPayload.candidateStatusTags = ['mapped'];
      interactionPayload.candidateId = passedCandidate.id;
      interactionPayload.id = passedCandidate.id;
      interactionPayload.recruiterJobMappingId = cachedJob?.activeWorkAssignment?.id ?? '';
      // setIsLoading(true);
      // const updatedInteraction = await createOrGetMappingForEdit(interactionPayload);
      // interactionToUse = interactionPayload;
      // } else {
      //   interactionToUse = activityConversation;
      //   interactionToUse.email = passedCandidate.email;
      //   interactionToUse.alternateEmails = passedCandidate.alternateEmails;
      //   interactionToUse.phoneNumber = passedCandidate.phoneNumber;
      //   interactionToUse.alternatePhoneNumbers = passedCandidate.alternatePhoneNumbers;
      // }
      setSelectedInteraction(interactionPayload);
      // setIsLoading(false);
    };
    initializeInteraction();
    fetchPhoneNumbers();
  }, [activityConversation, candidate, fromPage, pathName, user.userDTO?.email]);
  // const dummyMessages: IMsg[] = [
  //   {
  //     message: 'Hello, how are you?',
  //     direction: 'INBOUND',
  //     time: new Date('2024-04-18T10:00:00Z'),
  //   },
  //   {
  //     message: "I'm fine, thank you!",
  //     direction: 'OUTBOUND',
  //     time: new Date('2024-04-18T10:05:00Z'),
  //   },
  //   {
  //     message: `Absolutely! The role involves developing marketing strategies, creating content, and managing campaigns. We're offering a competitive salary of $55,000 per year, along with benefits like health insurance and a retirement plan. Does that sound good to you?`,
  //     direction: 'INBOUND',
  //     time: new Date('2024-04-18T10:10:00Z'),
  //   },
  //   {
  //     message: `Absolutely! The role involves developing marketing strategies, creating content, and managing campaigns. We're offering a competitive salary of $55,000 per year, along with benefits like health insurance and a retirement plan. Does that sound good to you?`,
  //     direction: 'OUTBOUND',
  //     time: new Date('2024-04-18T10:15:00Z'),
  //   },
  //   {
  //     message: "I'm fine, thank you!",
  //     direction: 'OUTBOUND',
  //     time: new Date('2024-04-18T10:05:00Z'),
  //   },
  //   {
  //     message: `Absolutely! The role involves developing marketing strategies, creating content, and managing campaigns. We're offering a competitive salary of $55,000 per year, along with benefits like health insurance and a retirement plan. Does that sound good to you?`,
  //     direction: 'INBOUND',
  //     time: new Date('2024-04-18T10:10:00Z'),
  //   },
  //   {
  //     message: `Absolutely! The role involves developing marketing strategies, creating content, and managing campaigns. We're offering a competitive salary of $55,000 per year, along with benefits like health insurance and a retirement plan. Does that sound good to you?`,
  //     direction: 'OUTBOUND',
  //     time: new Date('2024-04-18T10:15:00Z'),
  //   },
  //   {
  //     message: "I'm fine, thank you!",
  //     direction: 'OUTBOUND',
  //     time: new Date('2024-04-18T10:05:00Z'),
  //   },
  //   {
  //     message: `Absolutely! The role involves developing marketing strategies, creating content, and managing campaigns. We're offering a competitive salary of $55,000 per year, along with benefits like health insurance and a retirement plan. Does that sound good to you?`,
  //     direction: 'INBOUND',
  //     time: new Date('2024-04-18T10:10:00Z'),
  //   },
  //   {
  //     message: `Absolutely! The role involves developing marketing strategies, creating content, and managing campaigns. We're offering a competitive salary of $55,000 per year, along with benefits like health insurance and a retirement plan. Does that sound good to you?`,
  //     direction: 'OUTBOUND',
  //     time: new Date('2024-04-18T10:15:00Z'),
  //   },
  //   {
  //     message: "I'm fine, thank you!",
  //     direction: 'OUTBOUND',
  //     time: new Date('2024-04-18T10:05:00Z'),
  //   },
  //   {
  //     message: `Absolutely! The role involves developing marketing strategies, creating content, and managing campaigns. We're offering a competitive salary of $55,000 per year, along with benefits like health insurance and a retirement plan. Does that sound good to you?`,
  //     direction: 'INBOUND',
  //     time: new Date('2024-04-18T10:10:00Z'),
  //   },
  //   {
  //     message: `Absolutely! The role involves developing marketing strategies, creating content, and managing campaigns. We're offering a competitive salary of $55,000 per year, along with benefits like health insurance and a retirement plan. Does that sound good to you?`,
  //     direction: 'OUTBOUND',
  //     time: new Date('2024-04-18T10:15:00Z'),
  //   },
  // ];

  const [msgList, setMsgList] = useState<IMsg[]>([]);

  const { userDTO } = useUserContext();

  const setNotification = useNotificationStore((state) => state.setNotification);

  const sendMsg = useCallback(
    async (data: IMessageData) => {
      if (selectedInteraction) {
        const phoneValidity = validatePhoneNumber(data.to, selectedInteraction.currentLocation);
        const creditsNeeded = Math.ceil(data.message.length / 150);
        const creditMap = {
          '1': creditsNeeded,
          '61': 30 * creditsNeeded,
        };
        const selectedAccount = JSON.parse(data.from);
        if (
          selectedAccount.serviceName === 'WS_TELNYX' &&
          availableCredit < creditMap[phoneValidity.country]
        ) {
          setNotification(failed('You do not have enough credits to send this SMS.', 15000));
          return;
        }

        const canSendSmsResponse = await canSendSms(phoneValidity.number, selectedAccount.from);
        if (canSendSmsResponse.data.status === 'SENDING_ALLOWED') {
          const mapResponse = {
            ...selectedInteraction,
            phoneNumber: phoneValidity.number,
            mostRecentConversation: {
              result: {
                result: [],
                notes: '',
                createdOn: '',
                createdBy: '',
                createdByEmail: '',
              },
              notes: '',
              actions: ['Message', 'Sent SMS/Text'],
              createdOn: '',
              createdBy: '',
              createdByEmail: '',
              actionId: '',
              communicationId: '',
              communicationAccountId: selectedAccount.serviceAccountId,
              phoneNumber: phoneValidity.number,
            },
          };

          const payload: IBulkSmsDTO = {
            candidates: [
              {
                ...mapResponse,
                name: selectedInteraction.name ?? '',
                candidateId: selectedInteraction.id ?? '',
                isValid: true,
                countryCallingCode: '',
                mostRecentConversation: {
                  ...mapResponse.mostRecentConversation,
                  result: { ...mapResponse.mostRecentConversation.result, createdOn: new Date() },
                  actionId: new Date().toString(),
                  notes: data.message,
                  createdOn: new Date(),
                },
              },
            ],
            from: selectedAccount.from,
            message: data.message,
            notes: '',
            selectedAccount: selectedAccount.selectedAccount,
            serviceName: selectedAccount.serviceName,
          };
          const response = await sendBulkSms(payload);

          // const response = await sendSms({
          //   ...sendSmsPayload,
          //   message: data.message,
          //   from: selectedAccount.from,
          //   to: phoneValidity.number,
          //   actionId: new Date().toString(),
          //   interactionId: mapResponse.id ?? '',
          //   candidateId: selectedInteraction.id ?? '',
          //   candidateName: selectedInteraction.name ?? '',
          //   jobId: selectedInteraction.jobId ?? '',
          //   jobTitle: selectedInteraction.mappedJobTitle ?? '',
          //   workAssignmentId: mapResponse.data.recruiterJobMappingId ?? '',
          //   selectedAccount: selectedAccount.selectedAccount,
          // });
          const isSmsSent = response.data.sentSmsCount > 0;
          const isSkipped = response.data.sentSmsCount > 0;
          // if (response.data.status === 'success') {
          if (isSmsSent) {
            setMsgList((prev: IMsg[]) => [
              ...prev,
              { message: data.message, direction: 'OUTBOUND', time: new Date() },
            ]);
            setNotification(success('Message sent successfully!', 2000));
            if (amplitudeEventHandler) amplitudeEventHandler('Success');
          } else {
            // setNotification(failed(response.data.status, 15000));
            setNotification(
              failed(
                isSkipped
                  ? 'Message Not Sent as SMS was sent in past 24hrs'
                  : 'Failed to send Message',
                15000
              )
            );
            if (amplitudeEventHandler) amplitudeEventHandler('Failed');
          }
          onSubmit && onSubmit();
        } else {
          if (canSendSmsResponse.data.status === 'MAX_CONTACT_LIMIT_REACHED') {
            setNotification(
              failed(
                'To prevent spamming, it is not allowed to contact the candidate more than once a day. Please try again tomorrow. Contact Wisestep Customer Support for more information.',
                15000
              )
            );
          } else if (canSendSmsResponse.data.status === 'CANDIDATE_UNSUBSCRIBED') {
            setNotification(
              failed(
                'Candidate Unsubscribed! You are not allowed to send messages to this candidate.',
                15000
              )
            );
          } else {
            setNotification(failed('Cannot send message to this candidate', 15000));
          }
        }
      }
    },
    [amplitudeEventHandler, availableCredit, onSubmit, selectedInteraction, setNotification]
  );

  useEffect(() => {
    const getLogs = async () => {
      if (selectedInteraction) {
        const phoneValidity = validatePhoneNumber(to, selectedInteraction.currentLocation);
        let toNumber = to;
        if (phoneValidity.isValid) {
          toNumber = phoneValidity.number;
        }
        // const response = await getSmsLogs(toNumber, 1);
        const payload: SearchComLogReq = {
          to: toNumber,
          candidateId: selectedInteraction.id,
          page: 0,
          size: 50,
        };
        const logsResponse = await getSMSLogsV2(payload);
        const response = logsResponse.data.searchResult?.content ?? [];
        if (response && response.length) {
          setMsgList(
            response.reverse().map((log: ISmsLog) => ({
              message: log.body,
              direction: log.direction,
              time: log.createdOn,
            }))
          );
        } else {
          setMsgList([]);
        }
      }
    };
    getLogs();
  }, [selectedInteraction, to]);
  const workspace = useWorkspaceContext();
  return (
    <>
      {isLoading ? (
        <Box textAlign="center" pt={15}>
          <CircularProgress disableShrink sx={{ color: WsColors.TheBlues500 }} />
        </Box>
      ) : (
        phoneNumbers.length &&
        selectedInteraction && (
          <>
            {workspace.id === '0ed56aea-54c9-4485-987f-ffb35872eb38' ? (
              <WsChatBoxNew
                fromNumbers={phoneNumbers}
                receiverNumber={to ?? ''}
                receiverEmail={selectedInteraction?.email ?? ''}
                receiverName={selectedInteraction?.name ?? ''}
                senderEmail={userDTO?.email ?? ''}
                msgList={msgList}
                sendMsg={sendMsg}
                toNumbers={[selectedInteraction?.phoneNumber]
                  .concat(selectedInteraction?.alternatePhoneNumbers)
                  .map((number) => {
                    return { label: number ?? '', value: number ?? '' };
                  })}
                checkNumber={(phoneNumber) => {
                  setTo(phoneNumber);
                  return validatePhoneNumber(
                    phoneNumber,
                    selectedInteraction?.currentLocation ?? null
                  );
                }}
                jobCode={selectedInteraction?.jobCode ?? ''}
                jobTitle={selectedInteraction?.mappedJobTitle ?? ''}
              />
            ) : (
              <WsChatBox
                fromNumbers={phoneNumbers}
                receiverNumber={to ?? ''}
                receiverEmail={selectedInteraction?.email ?? ''}
                receiverName={selectedInteraction?.name ?? ''}
                senderEmail={userDTO?.email ?? ''}
                msgList={msgList}
                sendMsg={sendMsg}
                toNumbers={[selectedInteraction?.phoneNumber]
                  .concat(selectedInteraction?.alternatePhoneNumbers)
                  .map((number) => {
                    return { label: number ?? '', value: number ?? '' };
                  })}
                checkNumber={(phoneNumber) => {
                  setTo(phoneNumber);
                  return validatePhoneNumber(
                    phoneNumber,
                    selectedInteraction?.currentLocation ?? null
                  );
                }}
                jobCode={selectedInteraction?.jobCode ?? ''}
                jobTitle={selectedInteraction?.mappedJobTitle ?? ''}
              />
            )}
          </>
        )
      )}
      {phoneNumbers.length === 0 && selectedInteraction && (
        <Stack alignItems={'center'} justifyContent={'center'} height={'100vh'}>
          <WsTypography variant={WsTypoVariants.TITLE} color={WsTypoColors.TERTIARY}>
            SMS account for your profile is not set up. Please contact your workspace administrator.
          </WsTypography>
        </Stack>
      )}
    </>
  );
};

export default SMSChatBox;
